// extracted by mini-css-extract-plugin
export default {"root":"color_root__6T6RP","active":"color_active__duNaU"};